import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { LeftArrow } from "../../../Icons/Arrow/leftArrow.icon";
import { RightArrow } from "../../../Icons/Arrow/rightArrow.icon";
import { is } from "date-fns/locale";
import { data } from "jquery";
import Swal from "sweetalert2";
import PageNotFound from "../../notfound";

export default function PermissionDetail() {
  const { lang, proxy, auth, functions, pages } = useSelector((state) => state);
  const { normalizeString } = functions;
  const [searchList, setSearchList] = useState({
    list: [],
    currentIndex: 0,
  });
  const [searching, setSearching] = useState({
    feature: "",
    table: "",
  });
  const [isCollapse, setIsCollapse] = useState(false);
  const [users, setUsers] = useState([]);
  const debounceTimeout = useRef();
  const { id } = useParams();
  const location = useLocation();

  let navigate = useNavigate();
  const goToHomePage = () => {
    navigate(`/privileges`);
  };
  const [buttonPrivileges, setButtonPrivileges] = useState([
    { name: "read", id: "read" },
    { name: "write", id: "add" },
    { name: "modify", id: "update" },
    { name: "purge", id: "delete" },
    { name: "detail", id: "detail" },
    { name: "import", id: "import" },
    { name: "export", id: "export" },
  ]);

  const [group, setGroup] = useState({});
  /**
   *
   * Group_name
   *
   */
  const [isPages, setPages] = useState([]);
  const [views, setViews] = useState([]);
  const [refresh, setRefresh] = useState(0);

  const _token = localStorage.getItem("_token");

  useEffect(() => {
    fetch(`${proxy()}/auth/all/accounts`, {
      headers: {
        Authorization: _token,
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, data, status, content } = resp;
        if (success) {
          setUsers(data);
        } else {
          // window.location = "/login";
        }
      });
  }, []);

  useEffect(() => {
    const FetchDataAsync = async () => {
      const response = await fetch(
        `${proxy()}/privileges/group/${id}/ui/tree`,
        // `${proxy()}/api/tables/${id}`,
        {
          headers: {
            Authorization: _token,
          },
        }
      );
      const serializedData = await response.json();
      const { pages } = serializedData;
      setPages(pages);
      setViews(pages);
    };
    FetchDataAsync();
  }, [refresh]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.split("#")?.[1];
      const element = document.getElementById(id);
      element?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  }, [location]);

  const handleSearching = (key, value) => {
    setSearching((prev) => ({ ...prev, [key]: value }));
  };

  const handleSearchList = (list, index) => {
    setSearchList((prev) => ({
      currentIndex: index,
      list,
    }));
  };

  const handleRedirect = (url) => {
    navigate(url);
  };

  const handleRedirectSearching = (list = searchList.list, key) => {
    let index = searchList.currentIndex;

    switch (key) {
      case "next":
        index = searchList.currentIndex + 1;
        index = index > list.length - 1 ? list.length - 1 : index;
        break;
      case "prev":
        index = searchList.currentIndex - 1;
        index = index < 0 ? 0 : index;
        break;
      default:
        index = 0;
        break;
    }

    handleSearchList(list, index);
    handleRedirect(list.length > 0 ? `#${list[index].id}` : "");
  };

  if (
    !["uad", "pm"].includes(auth?.role) &&
    !auth?.ct?.find(
      ({ table_alias, update }) => table_alias === "privilegegroup" && update
    )
  ) {
    return <PageNotFound />;
  }
  const handleChangePrivileges = async (
    isAll = false,
    isAllInItem = false,
    checked = false,
    childrens,
    isRead = false
  ) => {
    let bodyData;
    let specailPri;
    if (isAll) {
      const buttons = (Array.isArray(childrens) ? childrens : [childrens])
        .map((item) => {
          if (
            item?.page_title?.toLowerCase().trim() === "accounts" ||
            item?.page_title?.toLowerCase().trim() === "privilegegroup"
          ) {
            specailPri = true;
          }
          return {
            page_title: item.page_title,
            table_alias: item.table_alias,
            buttons: item.buttons.map(({ cpn_id, id, name, child_id }) => {
              const isReadPermission = name.toLowerCase() === "read";

              if (isReadPermission) {
                return {
                  cpn_id: cpn_id,
                  [child_id || id]: checked,
                  [child_id || name]: checked,
                };
              }

              return {
                cpn_id: cpn_id,
                [child_id || id]: isRead ? false : checked,
                [child_id || name]: isRead ? false : checked,
              };
            }),
          };
        })
        .filter((item) => item.buttons.length > 0);

      if (buttons && buttons.length > 0) {
        bodyData = {
          data: {
            privilegegroup_id: parseInt(id),
            childrens: buttons,
            isAll: true,
            checked,
            specailPri,
          },
        };
      }
    } else {
      if (
        childrens.page_title.toLowerCase().trim() === "accounts" ||
        childrens.page_title.toLowerCase().trim() === "privilegegroup"
      ) {
        specailPri = true;
      }
      bodyData = {
        data: {
          privilegegroup_id: parseInt(id),
          childrens,
          isAll: false,
          checked,
          specailPri,
        },
      };
    }
    const request = await fetch(`${proxy()}/privileges/create/detail`, {
      method: "POST",
      headers: {
        Authorization: _token,
        "Content-type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });

    const response = await request.json();
    const { success, message } = response;
    if (success) {
      setRefresh((prev) => prev + 1);
    }
  };

  const handleSearchPages = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      const searchTerm = value.toLowerCase().trim();

      const list = views.filter((page) => {
        const pageTitle = page.page_title?.toLowerCase();
        const localizedTitle = lang[page.page_title]?.toLowerCase();
        return (
          pageTitle?.includes(searchTerm) ||
          localizedTitle?.includes(searchTerm)
        );
      });
      if (list.length > 0) {
        setPages(list);
      } else {
        setPages(views);
      }
    }, 1000);
  };

  return (
    <div class="midde_cont">
      <div class="container-fluid">
        <div class="row column_title">
          <div class="col-md-12">
            <div class="page_title d-flex align-items-center">
              <h4 class="ml-1">{lang["privileges manager"]}</h4>
            </div>
          </div>
        </div>
        <div class="row column1">
          <div class="col-md-12">
            <div class="white_shd full">
              <div
                class="full graph_head"
                style={{
                  borderBottom: " 1px solid rgb(221, 221, 221)",
                }}
              >
                <div class="heading1 margin_0">
                  <h5>
                    <label
                      class="pointer"
                      style={{ margin: 0 }}
                      onClick={() => navigate(-1)}
                    >
                      <a title={lang["back"]}>
                        <i class=" fa fa-chevron-circle-left mr-1 nav-item nav-link"></i>
                      </a>
                      {lang["privileges"]}
                    </label>
                  </h5>
                </div>
              </div>
              {searchList.list.length > 1 ? (
                <section
                  class="position-fixed d-flex align-items-center text-white"
                  style={{
                    right: "10px",
                    padding: "5px 20px",
                    gap: "20px",
                    borderRadius: "5px",
                    background: "#274452",
                  }}
                >
                  <div
                    class="hover_arrow"
                    onClick={() => {
                      handleRedirectSearching(searchList.list, "prev");
                    }}
                  >
                    <LeftArrow width="15px" height="15px" cursor="pointer" />
                  </div>
                  <p class="m-0 text-white">
                    {searchList.currentIndex + 1} / {searchList.list.length}
                  </p>
                  <div
                    class="hover_arrow"
                    onClick={() => {
                      handleRedirectSearching(searchList.list, "next");
                    }}
                  >
                    <RightArrow width="15px" height="15px" cursor="pointer" />
                  </div>
                </section>
              ) : null}
              <div
                className="privilege-pages w-100 p-0"
                style={{ height: "78vh", overflow: "auto" }}
              >
                <div
                  className="w-100"
                  style={{
                    padding: "6px 12px",
                  }}
                >
                  <table className="table-custom">
                    <thead
                      style={{
                        position: "sticky",
                        top: "-1px",
                        zIndex: 999999,
                      }}
                    >
                      <tr>
                        <td></td>
                        <td>Tên trang</td>
                        <td
                          style={{
                            width: "1%",
                          }}
                          className="align-center"
                        >
                          {lang["Actions"]}
                        </td>
                        {/* <td>
                        <input
                          type="search"
                          className="form-control"
                          onChange={(e) => handleSearchPages(e.target.value)}
                        />
                      </td> */}
                      </tr>
                    </thead>
                    <tbody key={refresh}>
                      <tr>
                        <td></td>
                        <td>
                          <input
                            type="search"
                            className="form-control"
                            onChange={(e) => handleSearchPages(e.target.value)}
                          />
                        </td>
                      </tr>
                      {isPages.map((page, index) => {
                        const { page_title, childrens } = page;
                        // const checkedAll = buttonPrivileges.every(
                        //   (item) => page[item.name] || page[item.id]
                        // );
                        const checkedAll =
                          childrens.length > 0 &&
                          childrens.every(
                            ({ buttons = [] }) =>
                              buttons.length > 0 &&
                              buttons.every(
                                (btn) => btn[btn.child_id || btn.id]
                              )
                          );
                        return (
                          <>
                            <tr>
                              <td
                                style={{
                                  width: "1%",
                                }}
                              >
                                <img
                                  onClick={() =>
                                    setIsCollapse((prev) => ({
                                      ...prev,
                                      [index]: !prev[index],
                                    }))
                                  }
                                  src={
                                    isCollapse[index]
                                      ? `/images/detail_minus.svg`
                                      : `/images/detail_plus.svg`
                                  }
                                  width={20}
                                  height={20}
                                />
                              </td>
                              <td
                                className="font-weight-bold"
                                style={{
                                  border: "unset !important",
                                  // height: "20px !important",
                                }}
                              >
                                {lang[page_title] || page_title}
                              </td>
                              <td className="">
                                <div
                                  class="form-check"
                                  onChange={(e) =>
                                    handleChangePrivileges(
                                      true,
                                      false,
                                      e.target.checked,
                                      childrens
                                    )
                                  }
                                >
                                  <input
                                    class="form-check-input pointer"
                                    type="checkbox"
                                    checked={checkedAll}
                                    id={index}
                                  />
                                  <label
                                    class="form-check-label pointer"
                                    for={index}
                                  >
                                    {lang["selectall"]}
                                  </label>
                                </div>
                              </td>
                            </tr>
                            {isCollapse[index] && (
                              <>
                                <tr>
                                  <td
                                    colSpan={3}
                                    style={{ paddingLeft: "40px" }}
                                  >
                                    <table className="table w-100">
                                      <thead></thead>
                                      <tbody>
                                        {childrens.map((child, childIndex) => {
                                          const { page_title, buttons = [] } =
                                            child;
                                          const checkedAll =
                                            buttons.length > 0 &&
                                            buttons.every(
                                              (item) =>
                                                item[item.child_id || item.id]
                                            );
                                          return (
                                            <>
                                              <tr className="table-Light">
                                                <td
                                                  className="align-center"
                                                  style={{
                                                    width: "1%",
                                                  }}
                                                >
                                                  {childIndex + 1}
                                                </td>
                                                <td className="font-weight-bold">
                                                  {lang[page_title] ||
                                                    page_title}
                                                </td>
                                                <td></td>
                                                {/* <td className="font-weight-bold align-center">
                                                {lang["Actions"]}
                                              </td> */}
                                              </tr>
                                              <tr key={childIndex} className="">
                                                <td className="border-0"></td>
                                                <td
                                                  colSpan={1}
                                                  className="border-0"
                                                >
                                                  <table className="table table-borderless m-0 m-2">
                                                    <thead>
                                                      <tr className="border-0">
                                                        <div>
                                                          <div className="buttons-container d-flex ml-2">
                                                            {buttons.map(
                                                              (
                                                                action,
                                                                actionIndex
                                                              ) => (
                                                                <div
                                                                  className="form-check mr-3"
                                                                  key={
                                                                    actionIndex
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      action.name ===
                                                                      "read"
                                                                    ) {
                                                                      handleChangePrivileges(
                                                                        true,
                                                                        false,
                                                                        e.target
                                                                          .checked,
                                                                        child,
                                                                        true
                                                                      );
                                                                    } else {
                                                                      handleChangePrivileges(
                                                                        false,
                                                                        false,
                                                                        e.target
                                                                          .checked,
                                                                        {
                                                                          ...action,
                                                                          page_title,
                                                                        }
                                                                      );
                                                                    }
                                                                  }}
                                                                >
                                                                  <input
                                                                    className="form-check-input pointer"
                                                                    type="checkbox"
                                                                    id={`${
                                                                      action.cpn_id ||
                                                                      child.table_alias
                                                                    }-${
                                                                      action.id
                                                                    }`}
                                                                    checked={
                                                                      action[
                                                                        action.child_id ||
                                                                          action.id
                                                                      ]
                                                                    }
                                                                  />
                                                                  <label
                                                                    className="form-check-label pointer"
                                                                    for={`${
                                                                      action.cpn_id ||
                                                                      child.table_alias
                                                                    }-${
                                                                      action.id
                                                                    }`}
                                                                  >
                                                                    {action.page_title ||
                                                                      lang[
                                                                        action
                                                                          .name
                                                                      ] ||
                                                                      action.name}
                                                                  </label>
                                                                </div>
                                                              )
                                                            )}
                                                          </div>
                                                        </div>
                                                      </tr>
                                                    </thead>
                                                  </table>
                                                </td>
                                                <td
                                                  className="align-center"
                                                  style={{
                                                    width: "1%",
                                                  }}
                                                >
                                                  <div
                                                    class="form-check"
                                                    onChange={(e) =>
                                                      handleChangePrivileges(
                                                        true,
                                                        false,
                                                        e.target.checked,
                                                        child
                                                      )
                                                    }
                                                  >
                                                    <input
                                                      class="form-check-input"
                                                      type="checkbox"
                                                      value=""
                                                      id="checkChildAll"
                                                      checked={checkedAll}
                                                    />
                                                    <label
                                                      class="form-check-label"
                                                      for="checkChildAll"
                                                    >
                                                      {lang["selectall"]}
                                                    </label>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const RenderChild = ({ button, checkTrigger, table, lang }) => {
    return (
      <div
        className=" permission_ui_hover_text py-1 px-2"
        style={{
          cursor: "pointer",
        }}
      >
        <div
          className="button d-flex align-items-center"
          style={{ gap: "10px" }}
          onChange={(e) => {
            checkTrigger(e, button, table.name);
          }}
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              checked={button.grantted}
            />
            <label class="form-check-label pointer">
              {lang[button.id] || button.page_title || lang[button.title]}
            </label>
          </div>
          {/* <div className="checkbox">
          <input
            type="checkbox"
            checked={button.grantted}
            id={button?.button?.id}
          />
        </div>
        <div
          className="button-name"
          style={{
            flex: "1",
          }}
        >
          <label
            className="w-100 m-0"
            style={{
              cursor: "pointer",
            }}
            for={button?.button?.id}
          >
            {lang[button.id] || button.page_title || lang[button.title]}
          </label>
        </div> */}
        </div>
      </div>
    );
  };
}
